import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { ReisekostenabrechnungStatiServiceModule } from '..';
import { ReisekostenabrechnungStatiSorterComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    ReisekostenabrechnungStatiServiceModule
  ],
  declarations: [ReisekostenabrechnungStatiSorterComponent],
  exports: [ReisekostenabrechnungStatiSorterComponent],

})
export class ReisekostenabrechnungStatiSorterComponentModule { }
